<template>
  <div
    :class="[
      $style.container,
      !currentInSlider ? $style.containerNoPadding : $style.containerPadding
    ]"
    ref="target"
    @mousemove="handleMouseMove">
    <p
      ref="text"
      :data-anim="!isInView ? 'fade' : false"
      data-anim-enter="fade"
      :class="$style.text"
      v-html="content"></p>
  </div>
</template>

<script>
import gsap from 'gsap'
import { mapGetters } from 'vuex'

export default {
  props: ['content'],
  computed: {
    ...mapGetters(['currentInSlider']),

    isInView() {
      return this.$route === 'tech-features' || this.$route === 'contact-us' || this.$route === 'work-with-us' || this.$route === 'about-us';
    },
  },
  methods: {
    handleMouseMove(event) {
      const el = this.$refs.text
      const bounding = el.getBoundingClientRect()

      if (!(navigator.userAgent.toLowerCase().indexOf("firefox") > -1)) {
        this.isMoving = true

        const t = Math.min(((event.pageX - bounding.left) / bounding.width) * 100, 85)
        const o = ((event.pageY - bounding.top) / bounding.height) * 100

        // const o = event.pageY - bounding.top

        gsap.to(this.$refs.text, 0.7, {
          background: `radial-gradient(200px at ${t}% ${o}%, rgba(0, 255, 255, 0.7), #0072CE, #1f1f1f)`,
          ease: Power2.easeOut,
          delay: 0.2
        })
      }
    },
  }
}
</script>

<style module lang="scss">
@import "~sass-mq/mq";

.container {
  padding: $big-margin-mobile 0;

  @include mq(sm) {
    padding: $big-margin 0;
  }

  &.containerNoPadding {
    padding: 0;
  }
}

.text {
  background: radial-gradient(200px at 50% 50%,rgba(0, 255, 255, 0.7), #0072CE, #1f1f1f);
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  cursor: default;

  max-width: 500px;
  font-size: 1.6rem;
  line-height: line-height(25px);

  div {
    background: inherit;
  }

  @include mq(sm) {
    width: 55%;
  }

  @include mq(ds) {
    font-size: font-size(xl);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GradientText.vue